import "./utils/polyfill";
import NexusLayoutCore from "./core/nexusLayoutCore";
import NexusLayoutPatient from "./patient/nexusLayoutPatient";
import "./styles/index.scss";

export default {
	NexusLayoutCore,
	NexusLayoutPatient
};
